<template>
  <div class="autocomplete">
    <h2 class="main-form__label">{{ $t("forms.enterAddress") }}</h2>

    <div class="autocomplete__content">
      <input
        type="text"
        ref="autocomplete"
        @focus="geolocate"
        class=" main-form__input"
        :placeholder="$t('forms.enterUrAddress')"
        v-model="value"
      />
    </div>

    <div class="buttons buttons_mt2">
      <button class="main-button main-button_cancel" @click="close">
        {{ $t("global.cancel") }}
      </button>

      <button
        class="main-button main-button_success"
        @click="save"
        :disabled="!isValid || result.length < 2"
        :class="{
          disabled: !isValid || result.length < 2,
        }"
      >
        {{ $t("global.save") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
    name: 'auto-complete',
    props: {
        disabled: {
            required: false,
            type: Boolean,
        },
        className: {
            required: false,
            type: String,
        },
        autocompleteValue: {
            required: false,
            default: '',
        },
    },
    watch: {
        autocompleteValue(v) {
            if (v !== null) {
                this.value = this.autocompleteValue
            }
        },
    },
    data() {
        return {
            autocomplete: null,
            fieds: ['route', 'street_number', 'postal_code', 'locality', 'country'],
            result: [],
            data: null,
            value: '',
        }
    },
    computed: {
        isValid() {
            if (!this.data) {
                return false
            }

            const {
                index, country, city, route, short_name,
            } = this.data.address
            const { lat, lng } = this.data.location

            return !!index && !!country && !!city && !!route && !!short_name && !!lat && !!lng
        },
    },
    methods: {
        getCountry() {
            return this.$config.behavior === 'profy' ? ['de'] : ['at']
        },
        initInput() {
            if (window.google !== undefined) {
                this.autocomplete = new window.google.maps.places.Autocomplete(
                    this.$refs.autocomplete,
                    { types: ['geocode'] },
                )
                this.autocomplete.setComponentRestrictions({
                    country: this.getCountry(),
                })
                this.autocomplete.setFields(['address_component', 'geometry'])

                window.google.maps.event.addListener(
                    this.autocomplete,
                    'place_changed',
                    () => {
                        this.fillInAddress()
                    },
                )
            }
        },
        fillInAddress() {
            this.result = []
            const places = this.autocomplete.getPlace()

            places.address_components.forEach((element) => {
                if (this.fieds.lastIndexOf(element.types[0]) !== -1) {
                    this.result.push(element)
                }
            })
            if (this.result.length < 5) {
                return
            }
            this.value = `${this.result[0].short_name} ${this.result[1].short_name}, ${this.result[4].long_name}, ${this.result[2].long_name}`

            this.data = {
                address: {
                    index: this.result[4].long_name,
                    country: this.result[3].long_name,
                    city: this.result[2].short_name,
                    route: this.result[1].short_name,
                    short_name: this.result[0].short_name,
                },
                location: {
                    lat: places.geometry.location.lat(),
                    lng: places.geometry.location.lng(),
                },
            }
        },
        geolocate() {
            if (
                window.navigator.geolocation
        && window.google !== undefined
        && this.autocomplete !== undefined
            ) {
                window.navigator.geolocation.getCurrentPosition((position) => {
                    const geolocation = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    }
                    const circle = new window.google.maps.Circle({
                        center: geolocation,
                        radius: position.coords.accuracy,
                    })

                    this.autocomplete.setBounds(circle.getBounds())
                })
            }
        },
        save() {
            this.$emit('done', this.data)
            this.close()
        },
        close() {
            this.value = ''
            this.$emit('close')
            this.result = []
        },
    },
    mounted() {
        this.initInput()
        this.value = this.autocompleteValue
    },
}
</script>

<style lang="scss" scoped>
.autocomplete {
  width: 350px;
  padding: 20px;

  &__input {
    padding-left: 20px;
    width: calc(100% - 30px);
    height: 45px;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    color: #444;
    font-size: 16px;
  }

  &__close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 126px;
    height: 40px;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    margin: 20px auto 10px;

    background-color: #f07300;
    transition: all 0.5s;
    cursor: pointer;
    position: relative;
    z-index: 9;
  }
}

.autocomplete .disabled_hover-orange {
  background: #f07300 !important;
}
</style>
